<div class="space-y-4">
    @if (loading) {
    <div class="flex flex-col items-center py-6 space-y-3">
        <app-loader></app-loader>
        <div class="font-medium">Loading</div>
    </div>
    } @else {
    <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-4">
        @for (field of fields; track field.key) {
        <div class="w-full">
            <label class="text-sm font-medium">{{ field.label }}</label>
            @if (field.hint) {
            <div class="text-xs text-gray-500">{{ field.hint }}</div>
            }
            <input type="number" class="input mt-1" [formControlName]="field.key" min="0"
                [ngClass]="{'input-invalid': form.get(field.key)?.invalid && form.get(field.key)?.touched}" />
            @if (form.get(field.key)?.invalid && form.get(field.key)?.touched) {
            <div class="error-message">กรุณากรอกค่า ≥ 0</div>
            }
        </div>
        }
    </form>

    <div class="flex justify-end pt-2 border-t">
        <button type="button" class="btn-sm btn-primary min-w-[8rem]" [disabled]="saving || form.invalid"
            (click)="submit()">
            @if (saving) { กำลังบันทึก... } @else { บันทึก }
        </button>
    </div>
    }
</div>
